import { getAddress } from 'ethers';
import { RUNTIME_CONFIG } from '@/lib/config/runtime-config';
import { APP_SETTINGS } from '@/lib/config/app-settings';

export const BSC_TESTNET = {
  get chainId() { return RUNTIME_CONFIG.chainId; },
  get chainIdHex() { return `0x${RUNTIME_CONFIG.chainId.toString(16)}`; },
  get chainName() { return RUNTIME_CONFIG.chainName; },
  get rpcUrl() { return RUNTIME_CONFIG.rpcUrls[0]; },
  get rpcUrls() { return RUNTIME_CONFIG.rpcUrls; },
  get readRpcUrl() { return RUNTIME_CONFIG.readRpcUrl; },
  get explorerUrl() { return RUNTIME_CONFIG.explorerUrl; },
  get nativeCurrency() { return RUNTIME_CONFIG.nativeCurrency; },
};

export const CONTRACTS = {
  get mining() { return getAddress(RUNTIME_CONFIG.contracts.mining); },
  get aethera() { return getAddress(RUNTIME_CONFIG.contracts.aethera); },
  get usdt() { return getAddress(RUNTIME_CONFIG.contracts.usdt); },
  get liquidityPool() { return getAddress(RUNTIME_CONFIG.contracts.liquidityPool); },
};

export const TOKEN_DECIMALS = APP_SETTINGS.tokenDecimals;
